import { PublicClientApplication, Configuration } from '@azure/msal-browser';

import {
    MICROSOFT_CLIENT_ID,
    MICROSOFT_TENANT_ID,
    getSsoRedirectUri,
    isMicrosoftSsoConfigured,
} from '@/config';

let msalInstance: PublicClientApplication | null = null;

export const getMsalInstance = (): PublicClientApplication | null => {
    if (!isMicrosoftSsoConfigured()) {
        return null;
    }

    if (!msalInstance) {
        const config: Configuration = {
            auth: {
                clientId: MICROSOFT_CLIENT_ID,
                authority: `https://login.microsoftonline.com/${MICROSOFT_TENANT_ID}`,
                redirectUri: getSsoRedirectUri(),
            },
            cache: {
                cacheLocation: 'sessionStorage',
            },
        };

        msalInstance = new PublicClientApplication(config);
    }

    return msalInstance;
};

export const microsoftLoginRequest = {
    scopes: ['openid', 'profile', 'email'],
};
